import { render } from "./BtnAtualizar.vue?vue&type=template&id=7cbfa0bd"
import script from "./BtnAtualizar.vue?vue&type=script&lang=js"
export * from "./BtnAtualizar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__